import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import { formatFileURL } from '../../utils/helper/appHelpers'
import { Print, Crop169Outlined } from '@mui/icons-material'
import { handlePrint } from './utils/print'
import { useCallback, useState } from 'react'
import ImageCropper from '../comman/ImageCropper'

export default function ServiceInfo({ item, status }) {
    const fileUrl = formatFileURL(item?.fileInfo?.url);
    const originalFileUrl = formatFileURL(item?.images?.[0]?.url);

    const [openCrop, setOpenCrop] = useState(false)

    const getRemark = () => {
        if (item?.shopServiceCategoryJson?.remarks?.length) {
            return item?.shopServiceCategoryJson?.remarks
        }
        return item?.shopServiceCategoryJson?.serviceCategoryId?.remarks
    }

    const handleDownload = () => handlePrint(fileUrl);

    const handleOpenCrop = useCallback(() => setOpenCrop(true), [])
    const handleCloseCrop = useCallback(() => setOpenCrop(false), [])

    const handleCropAndPrint = (blob) => handlePrint(blob);



    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={3}>
                    <Box sx={{ maxWidth: '100%', borderRadius: 1, maxHeight: 150 }} component={'img'} src={formatFileURL(item?.shopServiceCategoryJson?.thumbnail || item?.shopServiceCategoryJson?.serviceCategoryId?.thumbnailURL)} />
                </Grid>
                <Grid item md={5}>
                    <Typography variant='subtitle2'>{item?.shopServiceCategoryJson?.serviceCategoryId?.name}</Typography>
                    <Stack gap={2}>
                        {
                            getRemark()?.map(remark => <Typography variant='subtitle3'>{remark}</Typography>)
                        }
                    </Stack>
                    <Typography variant='subtitle3'>{item?.onsite ? 'Onsite' : 'Offsite'}</Typography>
                </Grid>
                <Grid item md={4} gap={2} sx={{ 'textAlign': 'right' }}>
                    <Typography variant='subtitle1'>${item?.totalPrice}</Typography>
                    {status !== "COMPLETED" && (
                        <>
                            <Button
                                className="btn-primary btn"
                                size="small"
                                variant="contained"
                                color="primary"
                                startIcon={<Print size={16} />}
                                onClick={handleDownload}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    borderRadius: 2,
                                    px: 2.5,
                                    py: 0.6,
                                    mr: 1,
                                    alignSelf: 'flex-end',
                                    background: 'linear-gradient(90deg, #1976d2 0%, #1565c0 100%)',
                                    boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                                    '&:hover': {
                                        background: 'linear-gradient(90deg, #1565c0 0%, #0d47a1 100%)',
                                        boxShadow: '0px 4px 6px rgba(0,0,0,0.15)',
                                    },
                                }}
                            >
                                Print
                            </Button>

                            {
                                originalFileUrl &&
                                <Button
                                    className="btn-primary btn"
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Crop169Outlined size={16} />}
                                    onClick={handleOpenCrop}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 500,
                                        borderRadius: 2,
                                        px: 2.5,
                                        py: 0.6,
                                        alignSelf: 'flex-end',
                                        background: 'linear-gradient(90deg, #1976d2 0%, #1565c0 100%)',
                                        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                                        '&:hover': {
                                            background: 'linear-gradient(90deg, #1565c0 0%, #0d47a1 100%)',
                                            boxShadow: '0px 4px 6px rgba(0,0,0,0.15)',
                                        },
                                    }}
                                >
                                    Crop
                                </Button>
                            }
                        </>
                    )}
                </Grid>
            </Grid>

            {openCrop && originalFileUrl && <ImageCropper
                open={openCrop}
                imageUrl={originalFileUrl}
                onClose={handleCloseCrop}
                onCropComplete={handleCropAndPrint}
            />}
        </>
    )
}
